import { mapToNamedProperty, NamedProperty } from "sprint-common-web";

import { OrdersAirlineLookupItemResponse } from "../../../common/api/orders-api/airline/GetOrdersAirlinesLookupResponse";
import { DynamicSubtitleType, mapNumberToDynamicSubtitleType } from "../../../common/types/DynamicSubtitleType";
import { mapToOrderAudioProxyType, OrderAudioProxyType } from "./OrderAudioProxyType";
import { mapToSystemPlatformSpecification, SystemPlatformSpecification } from "./SystemPlatformSpecification";

export interface OrdersAirline {
    id: string;
    name: string;
    code: string;
    systemPlatforms: SystemPlatform[];
}

export interface SystemPlatform {
    system: NamedProperty;
    integrator: NamedProperty;
    specifications: SystemPlatformSpecification[];
    deliveryEndpoint: NamedProperty | undefined;
    muxSubtitleType: DynamicSubtitleType | undefined;
    copySubtitleType: DynamicSubtitleType | undefined;
    audioProxyType: OrderAudioProxyType | undefined;
    muxSpecification: NamedProperty | undefined;
    subtitlesTargetFileName: string | undefined;
    buzzIds?: string[];
    shreqIds?: string[];
}

export const mapToOrdersAirline = (response: OrdersAirlineLookupItemResponse): OrdersAirline => {
    return {
        id: response.id,
        name: response.name,
        code: response.code,
        systemPlatforms: response.systemPlatforms.map((systemPlatform) => ({
            system: mapToNamedProperty(systemPlatform.system),
            integrator: mapToNamedProperty(systemPlatform.integrator),
            specifications: systemPlatform.specifications.map((item) => mapToSystemPlatformSpecification(item)),
            muxSpecification: systemPlatform.muxSpecification
                ? mapToNamedProperty(systemPlatform.muxSpecification)
                : undefined,
            subtitlesTargetFileName: systemPlatform.subtitlesTargetFileName,
            deliveryEndpoint: systemPlatform.deliveryEndpoint
                ? mapToNamedProperty(systemPlatform.deliveryEndpoint)
                : undefined,
            buzzIds: systemPlatform.buzzIds,
            shreqIds: systemPlatform.shreqIds,
            muxSubtitleType: systemPlatform.muxSubtitleType
                ? mapNumberToDynamicSubtitleType(systemPlatform.muxSubtitleType)
                : undefined,
            copySubtitleType: systemPlatform.copySubtitleType
                ? mapNumberToDynamicSubtitleType(systemPlatform.copySubtitleType)
                : undefined,
            audioProxyType: systemPlatform.audioProxyType
                ? mapToOrderAudioProxyType(systemPlatform.audioProxyType)
                : undefined
        }))
    };
};
